import axios, { type AxiosResponse } from 'axios'

import type { PaginatedResponse } from '@/api/schemas/common/pagination'
import { API_ENDPOINTS } from '@/constants/apiEndpoints'
import type { CooperationOrderStatusDictItem } from '@/types/domain/orders/cooperant'

export type CooperantOrderStatusesResponse = PaginatedResponse<CooperationOrderStatusDictItem>

class CooperantOrderStatusesQueries {
    fetchAll(): Promise<AxiosResponse<CooperantOrderStatusesResponse>> {
        return axios.get<CooperantOrderStatusesResponse>(`${API_ENDPOINTS.ORDERS.STATUSES}?domain=cooperation`)
    }
}

export default new CooperantOrderStatusesQueries()
